import React, { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Text,
  Button,
  Image,
  Flex,
  SimpleGrid,
  Container,
  Badge,
  HStack,
  VStack,
  Icon,
} from "@chakra-ui/react";
import { FiCheck, FiArrowRight, FiShield, FiCpu, FiDatabase, FiAward } from "react-icons/fi";
import { apiUrl } from "../ApiUrl/ApiUrl";
import Slider from "react-slick";
import { Link, NavLink } from "react-router-dom";

function LegitQuest() {
  const [fashion, setFashion] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data2, setData2] = useState(null);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const getFashion = () => {
    setLoading(true);
    fetch(`${apiUrl}/public/allbooks`)
      .then((res) => res.json())
      .then((res) => setFashion(res))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  };

  const getPrice2 = () => {
    setLoading(true);
    fetch(`${apiUrl}/public/singleBook?bid=560`)
      .then((res) => res.json())
      .then((res) => setData2(res))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getFashion();
    getPrice2();
  }, []);

  return (
    <Box bg="#F8FAFC" minH="100vh" pb={16}>
      {/* SaaS Hero Header */}
      <Box
        bgGradient="linear(to-b, #0B132B, #162237)"
        color="white"
        py={{ base: 12, md: 16 }}
        px={{ base: 4, md: 8 }}
        textAlign="center"
      >
        <Container maxW="900px">
          <Badge
            bg="whiteAlpha.200"
            color="#EAB308"
            px={3}
            py={1}
            rounded="full"
            fontSize="xs"
            fontWeight="bold"
            letterSpacing="wider"
            mb={4}
          >
            ⚖️ AI-DRIVEN LEGAL INTELLIGENCE & CITATION MAP
          </Badge>

          <Heading
            as="h1"
            fontSize={{ base: "30px", md: "46px" }}
            fontWeight="extrabold"
            letterSpacing="tight"
            mb={3}
          >
            Legit Quest
          </Heading>

          <Text
            fontSize={{ base: "sm", md: "lg" }}
            color="gray.300"
            maxW="750px"
            mx="auto"
            lineHeight="tall"
          >
            Transforming Indian legal research with i-DRAF AI technology — segregating Issues, Facts, Arguments, Reasoning, and Decision in seconds.
          </Text>
        </Container>
      </Box>

      {/* Main Content: Plans & Product Showcase */}
      <Container maxW="1200px" mt={-8} px={{ base: 3, md: 6 }}>
        <Box
          bg="white"
          rounded="2xl"
          border="1px solid"
          borderColor="gray.200"
          shadow="sm"
          p={{ base: 5, md: 8 }}
        >
          <Flex direction={{ base: "column", lg: "row" }} gap={{ base: 8, lg: 10 }} align="center">
            {/* Left: Pricing & Subscription */}
            <Box w={{ base: "100%", lg: "55%" }}>
              <HStack spacing={2} mb={1}>
                <Text fontSize="xs" fontWeight="bold" color="#EAB308" textTransform="uppercase" letterSpacing="wider">
                  AI Research Subscription
                </Text>
              </HStack>
              <Heading size="lg" color="#162237" fontWeight="bold" mb={6}>
                Full Legal Intelligence Suite
              </Heading>

              <Box
                p={{ base: 5, md: 6 }}
                rounded="xl"
                border="2px solid"
                borderColor="#162237"
                bg="white"
                shadow="sm"
                position="relative"
              >
                <Badge
                  position="absolute"
                  top={-3}
                  right={4}
                  bg="#162237"
                  color="#EAB308"
                  fontSize="10px"
                  px={2.5}
                  py={0.5}
                  rounded="full"
                  fontWeight="bold"
                >
                  i-DRAF AI POWERED
                </Badge>

                <Flex justify="space-between" align="flex-start" wrap="wrap" gap={2}>
                  <Box>
                    <Heading size="md" color="#162237">
                      Legit Quest Complete
                    </Heading>
                    <Text fontSize="xs" color="gray.600" mt={1}>
                      Supreme Court, All High Courts, Tribunals & Commissions, Notifications, Circulars & Statutory Rules
                    </Text>
                  </Box>

                  <Box textAlign={{ base: "left", sm: "right" }}>
                    <HStack spacing={2} align="baseline">
                      <Text fontSize="2xl" fontWeight="extrabold" color="#162237">
                        ₹{data2?.descprice ? data2.descprice : "—"}
                      </Text>
                      {data2?.originalprice && (
                        <Text fontSize="xs" color="gray.400" as="del">
                          ₹{data2.originalprice}
                        </Text>
                      )}
                    </HStack>
                    <Text fontSize="10px" color="gray.500">+ 18% GST Applicable</Text>
                  </Box>
                </Flex>

                <VStack spacing={2} mt={4} pt={4} borderTop="1px solid" borderColor="gray.100" align="stretch">
                  <HStack spacing={2} fontSize="xs" color="gray.700">
                    <Icon as={FiCheck} color="green.600" boxSize={3.5} />
                    <Text>Patent-pending i-DRAF judgment breakdown</Text>
                  </HStack>
                  <HStack spacing={2} fontSize="xs" color="gray.700">
                    <Icon as={FiCheck} color="green.600" boxSize={3.5} />
                    <Text>Judicial treatment maps (Affirmed, Overruled, Distinguished)</Text>
                  </HStack>
                  <HStack spacing={2} fontSize="xs" color="gray.700">
                    <Icon as={FiCheck} color="green.600" boxSize={3.5} />
                    <Text>One-click PDF downloads and citation copying</Text>
                  </HStack>
                </VStack>

                <Link to="/products/view/560">
                  <Button
                    mt={5}
                    w="100%"
                    size="md"
                    bg="#162237"
                    color="white"
                    _hover={{ bg: "#0F172A" }}
                    rounded="lg"
                    rightIcon={<FiArrowRight />}
                  >
                    Subscribe to Legit Quest
                  </Button>
                </Link>
              </Box>
            </Box>

            {/* Right: Product Banner Image */}
            <Box w={{ base: "100%", lg: "45%" }} textAlign="center">
              <Box
                p={4}
                bg="#F1F5F9"
                rounded="2xl"
                border="1px solid"
                borderColor="gray.200"
              >
                <Image
                  src="./legit-quest.jpeg"
                  alt="Legit Quest"
                  maxH="380px"
                  mx="auto"
                  objectFit="contain"
                  rounded="xl"
                  fallbackSrc="https://navneetlawstudio.com/logo.png"
                />
              </Box>
            </Box>
          </Flex>
        </Box>

        {/* Feature Highlights Grid */}
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6} mt={8}>
          <Box bg="white" p={5} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
            <Flex w="40px" h="40px" rounded="lg" bg="blue.50" color="#162237" align="center" justify="center" mb={3} fontSize="18px">
              <FiCpu />
            </Flex>
            <Text fontSize="sm" fontWeight="bold" color="gray.800" mb={1}>
              i-DRAF Extraction
            </Text>
            <Text fontSize="xs" color="gray.600" lineHeight="tall">
              Instantly view separated paragraphs corresponding to Issues, Facts, Contentions, Reasoning, and Operative Decision.
            </Text>
          </Box>

          <Box bg="white" p={5} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
            <Flex w="40px" h="40px" rounded="lg" bg="purple.50" color="purple.700" align="center" justify="center" mb={3} fontSize="18px">
              <FiAward />
            </Flex>
            <Text fontSize="sm" fontWeight="bold" color="gray.800" mb={1}>
              Treatment Analysis
            </Text>
            <Text fontSize="xs" color="gray.600" lineHeight="tall">
              Color-coded radar indicators showing whether a judgment remains good law or was subsequently overruled or clarified.
            </Text>
          </Box>

          <Box bg="white" p={5} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
            <Flex w="40px" h="40px" rounded="lg" bg="green.50" color="green.700" align="center" justify="center" mb={3} fontSize="18px">
              <FiShield />
            </Flex>
            <Text fontSize="sm" fontWeight="bold" color="gray.800" mb={1}>
              Enterprise Security
            </Text>
            <Text fontSize="xs" color="gray.600" lineHeight="tall">
              Secure single sign-on (SSO), chamber user management, and saved case folders for ongoing litigation matters.
            </Text>
          </Box>
        </SimpleGrid>

        {/* Recommended Softwares Slider */}
        <Box mt={12}>
          <Flex justify="space-between" align="center" mb={4}>
            <Box>
              <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase" letterSpacing="wider">
                Explore More Tools
              </Text>
              <Heading size="md" color="#162237">
                Recommended Legal Softwares
              </Heading>
            </Box>
            <Link to="/software">
              <Button size="xs" variant="outline" colorScheme="navy">
                View All Softwares
              </Button>
            </Link>
          </Flex>

          <Box
            p={4}
            bg="white"
            rounded="xl"
            border="1px solid"
            borderColor="gray.200"
            shadow="xs"
          >
            <Slider {...settings}>
              {fashion
                .filter((item) => item.maincatname === "software" || item.subcatname === "software")
                .map((item) => (
                  <Box key={item.id} p={2}>
                    <NavLink to={`/products/view/${item.id}`}>
                      <Box
                        bg="gray.50"
                        rounded="lg"
                        border="1px solid"
                        borderColor="gray.200"
                        p={3}
                        textAlign="center"
                        _hover={{ borderColor: "#162237", bg: "white", shadow: "sm" }}
                        transition="all 0.2s"
                        h="100%"
                      >
                        <Image
                          src={item.imagePath}
                          alt={item.booktitle}
                          h="120px"
                          mx="auto"
                          objectFit="contain"
                          fallbackSrc="https://navneetlawstudio.com/logo.png"
                        />
                        <Text
                          fontSize="xs"
                          fontWeight="bold"
                          color="gray.800"
                          mt={2}
                          noOfLines={2}
                          minH="32px"
                        >
                          {item.booktitle}
                        </Text>
                        <HStack justify="center" spacing={2} mt={1}>
                          <Text fontSize="xs" fontWeight="bold" color="#162237">
                            ₹{item.descprice}
                          </Text>
                          {item.originalprice && (
                            <Text fontSize="10px" color="gray.400" as="del">
                              ₹{item.originalprice}
                            </Text>
                          )}
                        </HStack>
                      </Box>
                    </NavLink>
                  </Box>
                ))}
            </Slider>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default LegitQuest;

